var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.classStyle,style:({
    '--color': _vm.color,
    '--start-day': _vm.determineStartDay + '-start',
    '--end-day': _vm.determineEndDay + '-end',
  }),attrs:{"role":"button","draggable":_vm.draggable},on:{"dragstart":_vm.startDrag,"mouseenter":_vm.handleMouseEnter,"mouseleave":_vm.handleMouseLeave}},[_vm._t("default"),((_vm.$slots.popover || _vm.$scopedSlots.popover) && _vm.showPopOver)?_c('pop-over',{attrs:{"bounds":_vm.bounds}},[_vm._t("popover")],2):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }